module.exports = __webpack_public_path__ + "static/media/brand_logo.badc79ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/client/shared/images/brand_logo.png
// module id = 783
// module chunks = 0